<template>
  <div class="tabs-form main-create-page">
    <v-card>
      <v-card-text>
        <div class="d-flex align-center pb-2">
          <div>
            <h3 class="font-weight-700 font-size-24 color-custom-blue">
              <span v-if="templateId > 0">Edit</span>
              <span v-else>Create</span>
              Checklist
            </h3>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="custom-grey-border custom-bold-button"
            v-on:click="goBack"
          >
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
          <v-btn
            class="custom-bold-button ms-2"
            depressed
            :disabled="pageLoading"
            color="cyan white--text"
            v-on:click="updateOrCreate()"
          >
            {{ isEdit ? 'Update' : 'Save' }}
          </v-btn>
        </div>

        <v-row>
          <v-col cols="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-card-title
                class="headline grey lighten-4"
                @click="ManageCard('basic')"
              >
                <h3 class="font-weight-700 custom-headline color-custom-blue">
                  <v-icon>{{
                    !show_add_form ? "mdi-chevron-down" : "mdi-chevron-up"
                  }}</v-icon>
                  Basic Details
                </h3>
              </v-card-title>
              <v-expand-transition>
                <v-card-text class="p-6 font-size-16" v-show="show_add_form">
                  <v-form
                    ref="createTemplateForm"
                    v-model="formValid"
                    lazy-validation
                    v-on:submit.stop.prevent="updateOrCreate()"
                  >
                    <v-row>
                      <v-col md="2" class="my-auto">
                        <label for="" class="v-label">Title</label>
                      </v-col>
                      <v-col md="6">
                        <TextField
                          dense
                          filled
                          solo
                          flat
                          placeholder="Enter Title"
                          hide-details
                          color="cyan"
                          :loading="pageLoading"
                          :disabled="pageLoading"
                          v-model="serviceFormTemplateCreate.title"
                          :rules="[
                            validateRules.required(
                              serviceFormTemplateCreate.title,
                              'Title'
                            ),
                          ]"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="2" class="my-auto">
                        <label for="" class="v-label">Description</label>
                      </v-col>
                      <v-col md="6">
                        <TextAreaField
                          auto-grow
                          dense
                          filled
                          color="cyan"
                          v-model.trim="serviceFormTemplateCreate.description"
                          placeholder="Description"
                          solo
                          flat
                          row-height="20"
                          counter="200"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                     
                    <v-col md="2" class="my-auto">
                      <div class="d-flex justify-space-between" md="2">
                          <label for="" class="v-label">Category</label>
                      </div>
                    </v-col>
                      <v-col md="6">
                        <v-select
                          dense
                          filled
                          multiple
                          solo
                          flat
                          hide-details
                          color="cyan"
                          placeholder="Select category"
                          :items="categoryList"
                          item-text="text"
                          item-value="id"
                          v-model="serviceFormTemplateCreate.categories"
                          :disabled="pageLoading"
                        />
                      </v-col>
                      <v-icon small @click="manageGroupDialog = true">mdi-cog</v-icon>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card flat class="custom-grey-border remove-border-radius">
              <v-card-title
                class="headline grey lighten-4"
                @click="ManageCard('builder')"
              >
                <h3 class="font-weight-700 custom-headline color-custom-blue">
                  <v-icon>{{
                    !show_form_builder ? "mdi-chevron-down" : "mdi-chevron-up"
                  }}</v-icon>
                  Cheklist Builder
                </h3>
              </v-card-title> 
              <v-expand-transition>
                <v-card-text class="p-6 font-size-16" v-if="show_form_builder">
                  <FormBuilder
                    :data="serviceFormTemplateCreate"
                    :preBuilderData="preBuilderData"
                    :title="serviceFormTemplateCreate.title"
                    @update-data="updateData"
                  />
                </v-card-text>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template v-if="manageGroupDialog">
      <ManageCategory
          Equipment
          :c-dialog="manageGroupDialog"
          :category="categoryList"
          v-on:close-dialog="manageGroupDialog = false"
          v-on:get-product-category="loadCategoryOptions"
        ></ManageCategory>
    </template>
  </div>
   

</template>
<script>
import FormBuilder from "@/view/pages/serviceFormTemplate/FormBuilder";
import ManageCategory from "@/view/pages/partials/Manage-Product-Category.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";
import {
  POST,
  GET,
  PUT,
  QUERY,
  CLEAR_ERROR,
} from "@/core/services/store/request.module";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import { map } from "lodash";

export default {
  mixins: [ValidationMixin],
  name: "Form_builder",
  data() {
    return {
      categoryList: [],
      equipmentList: [],
      preBuilderData: [],
      show_add_form: false,
      isEdit:false,
      show_form_builder: true,
      show_equipment_assign: false,
      manageGroupDialog :false,
      templateId: null,
      serviceFormTemplateCreate: {
        title: null,
        description: null,
        category: null,
        categories: [],
        checklist_data: [],
        equipments: [],
        equipments_list: [],
      },
      pageLoading: false,
      equipmentSelectDialog: false,
      detail: {},
    };
  },

  methods: {
    ManageCard(type) {
      if (type == "builder") {
        this.show_form_builder = !this.show_form_builder;
        this.show_add_form = false;
        this.show_equipment_assign = false;
      } else if (type == "basic") {
        this.show_form_builder = false;
        this.show_add_form = !this.show_add_form;
        this.show_equipment_assign = false;
      } else if (type == "equipment") {
        this.show_form_builder = false;
        this.show_add_form = false;
        this.show_equipment_assign = !this.show_equipment_assign;
      }
    },
    updateData(data) {
      this.serviceFormTemplateCreate.checklist_data = data;
    },
    updateOrCreate() {
      const _this = this;
      if (!_this.$refs.createTemplateForm.validate()) {
        return false;
      }
      _this.pageLoading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});
      let requestType = POST;
      let requestURL = "setting/checklist";
      if (_this.templateId && _this.templateId > 0) {
        requestType = PUT;
        requestURL = `setting/checklist/${_this.templateId}`;
      }
      let requestData = _this.serviceFormTemplateCreate;
      console.log("requestData", requestData);
      _this.$store
        .dispatch(requestType, { url: requestURL, data: requestData })
        .then((response) => {
          _this.templateId = response.data ? response.data.id : null;
          _this.goBack();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    loadData() {
      const _this = this;
      this.$store
        .dispatch(GET, { url: `setting/checklist/${_this.templateId}` })
        .then((response) => {
          const payload = response.data || {};
          const categoryIds = (payload.categories || []).map((row) => row.id);
         
          payload.categories = categoryIds;
          console.log({categoryIds});
          payload.category = categoryIds.length ? categoryIds[0] : null;
          _this.serviceFormTemplateCreate = payload;

          console.log(_this.serviceFormTemplateCreate);


          _this.detail = payload;
          if (
            _this.serviceFormTemplateCreate &&
            _this.serviceFormTemplateCreate.checklist_data
          ) {
            _this.preBuilderData =
              _this.serviceFormTemplateCreate.checklist_data;
          }
          if (
            _this.serviceFormTemplateCreate &&
            _this.serviceFormTemplateCreate.equipment
          ) {
            _this.serviceFormTemplateCreate.equipments = map(
              _this.serviceFormTemplateCreate.equipment,
              (row) => row.id
            );
            _this.serviceFormTemplateCreate.equipments_list =
              _this.serviceFormTemplateCreate.equipment;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCategoryOptions() {
      this.$store
        .dispatch(QUERY, {
          url: "equipment/options",
          data: {
            type: "main_customer",
          },
        })
        .then(({ data }) => {
          if(data.category)
          {
            this.categoryList = map(data.category, (row) => {
              row.id = Number(row.id);
              return row;
            });
          }
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    onEquipmentSelected(equipments) {
      if (equipments && equipments.length > 0) {
        this.serviceFormTemplateCreate.equipments = equipments.map(
          (equipment) => equipment.id
        );
        this.serviceFormTemplateCreate.equipments_list = equipments;
      }
      this.equipmentSelectDialog = false;
    },
    addNewEquipment(index) {
      this.serviceFormTemplateCreate.equipments_list.splice(index + 1, 0, {
        name: null,
        barcode: null,
        id: null,
      });
    },
    removeEquipment(index) {
      this.serviceFormTemplateCreate.equipments_list.splice(index, 1);
      // Update the equipments array to match
      this.serviceFormTemplateCreate.equipments =
        this.serviceFormTemplateCreate.equipments_list
          .map((e) => e.id)
          .filter((id) => id);
    },
  },
  created() {
    const _this = this;
    _this.templateId = _this.lodash.toSafeInteger(_this.$route.params.id);
  },
  mounted() {
    const _this = this;
    _this.loadCategoryOptions();
    if (_this.$route.name == "admin.serviceFormTemplate.update") {
      if (_this.templateId <= 0) {
        _this.$router.go(-1);
      }

      _this.loadData();
    }
    if (this.$route.params.id) {
    this.isEdit = true;
  }
  },
  components: {
    FormBuilder,
    ManageCategory,
    TextAreaField,
  },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs > .v-tabs-bar .v-tab.v-tab--active {
  background-color: #00bcd4 !important;
  color: #fff !important;
  overflow: hidden;
}

.custom-tab-transparent.v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tab.v-tab--active
  .grey--text.text--darken-4 {
  color: #fff !important;
  caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
  background: #00bcd429;
  width: 25%;
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}
</style>
